// @flow
import { createRef, useState } from "react";
import { TextInput } from "@nested/brand";
import { getImage } from "@nested/utils";
import {
  Heading,
  QuestionDescription,
  QuestionAndImageWrapper,
  PrivacyPolicyCheckbox,
} from "../components";
import { useDesktopFocus } from "../hooks/useDesktopFocus";
import { type QuestionProps } from "../components/MultiStageForm";
import {
  composeValidators,
  validateEmail,
  validatePresence,
} from "./validators";

const validate = async (email = {}) => {
  const result = await composeValidators(
    validatePresence("email", "Please enter a valid email address"),
    validateEmail("email", "Please enter a valid email address"),
  )(email?.email);
  return result;
};

type EmailAdditionalProps = { descriptionCopy?: string };
type EmailProps = QuestionProps<"email"> & EmailAdditionalProps;

export const Email = ({
  ActionButtons,
  BackButton,
  initialValue,
  next,
  valid,
  validationErrors,
}: EmailProps) => {
  const [privacyPolicyConsent, setPrivacyPolicyConsent] = useState(
    initialValue?.privacyPolicyConsent || false,
  );
  const [email, setEmail] = useState(initialValue?.email || "");
  const ref = createRef();
  useDesktopFocus(ref);

  return (
    <QuestionAndImageWrapper
      next={() => next({ email, privacyPolicyConsent }, validate)}
      dataTest="what-is-your-email-question"
      imageUrl={getImage("marketing/onboarding-account-preview.png")}
    >
      <BackButton />
      <Heading>What's your email address?</Heading>
      <QuestionDescription>
        We're creating you a Nested account to unlock smart insights about your
        home.
      </QuestionDescription>

      <TextInput
        className="fs-exclude"
        data-test="onboarding-form:email"
        errorMessage={validationErrors.email}
        hasErrors={!valid}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Email address"
        ref={ref}
        type="email"
        value={email}
      />
      <PrivacyPolicyCheckbox
        css="margin-top: 30px;"
        checked={privacyPolicyConsent}
        onChange={setPrivacyPolicyConsent}
      />
      <ActionButtons />
    </QuestionAndImageWrapper>
  );
};
